module.exports = __webpack_public_path__ + "static/media/planning_title_ko@2x.35d00e18.png";